import React from "react";

import { ComponentInvalidStatusIcon } from "./ComponentInvalidStatusIcon";
import { StyledBoxWrapper } from "./ComponentInvalidStatusIconWrapper.style";
import type { ComponentInvalidStatusIconProps } from "./types";

export const ComponentInvalidStatusIconWrapper = (props: ComponentInvalidStatusIconProps) => {
  return (
    <StyledBoxWrapper>
      <ComponentInvalidStatusIcon {...props} />
    </StyledBoxWrapper>
  );
};
